import { useCallback } from "react"
import { useTranslation } from "react-i18next"

/**
 * Vehicle class code (TRUCK_SMALL ...) -> localized label. The ONE conversion list for the vehicle
 * registry, the route detail and the route wizard (O119 / O188): a raw code is never shown.
 */
export function useVehicleClassLabel() {
  const { t } = useTranslation(["delivery"])
  return useCallback(
    (code: string | null | undefined): string => {
      if (!code) return "-"
      return t(`delivery:vehicle.class.${code}`, { defaultValue: "-" })
    },
    [t],
  )
}
